import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth';
import * as ROUTES from './../constants/routes'


const ProtectedRoute = ({
    children,
}) => {
    const {
        authLoading,
        isGuest,
    } = useAuth()


    return (
        (
            !isGuest
            || (isGuest && authLoading)
        )
        ? children
        : <Navigate
            to={`${ROUTES.SIGN_IN}?redirect_to=${window.location.pathname}`}
            replace
        />
    )
};

export default React.memo(ProtectedRoute)